$('div[popoverButton]').click(function () {
    var id = $(this).attr('popoverButton');
    if ($('.popup--content[popoverContent="' + id + '"]').is(':visible')) {
        $('.popup--content[popoverContent="' + id + '"]').fadeOut();
        $(this).removeClass('active');
    } else {
        $('.popup--content[popoverContent="' + id + '"]').fadeIn();
        $('.popup--content:not([popoverContent="' + id + '"])').fadeOut();
        $(this).addClass('active');
    }

    $(document).mouseup(function (e) {
        var container = $('.popup--content');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.popup--content').fadeOut();
            $('div[popoverButton]').removeClass('active');
        }
    });
});

// copy current url to clipboard (blog single)
function copyLink() {
    var copyText = window.location.href;
    navigator.clipboard.writeText(copyText);
}
$('.copy--link').click(function (e) {
    e.preventDefault();
    copyLink();
    return false;
});


$('.accordion--programm .click--down').click(function(){
    if ($(this).hasClass('down')) {
        $(this).parent().parent().find(".accordion--slide").slideDown().addClass('acc--show');
        $(this).addClass("up").removeClass("down");
    } else {
        $(this).parent().parent().find(".accordion--slide").slideUp().removeClass('acc--show');
            $(this).addClass("down").removeClass("up");
    }
})

$('.accordion--speaker .click--down').click(function(){
    if ($(this).hasClass('down')) {

        $(".accordion--slide").slideUp().removeClass('acc--show');
        $('.accordion--speaker .click--down').addClass("down").removeClass("up");

        $(this).parent().find(".accordion--slide").slideDown().addClass('acc--show');
        $(this).addClass("up").removeClass("down");
    } else {
        $(this).parent().find(".accordion--slide").slideUp().removeClass('acc--show');
            $(this).addClass("down").removeClass("up");
    }
})